const icoTerminal = "/frontend/web/img/map/marker-blue.svg";
const icoStore = "/frontend/web/img/map/marker-orange.svg";

declare const google: any;
export const getIcon = (type: "terminal" | "store") => ({
    anchor: new google.maps.Point(18, 47),
    size: new google.maps.Size(37, 47),
    url: type == "terminal" ? icoTerminal : icoStore,
    scaledSize: new google.maps.Size(37, 47),
});
